import { Realizado } from './realizado';
import { Trimestre } from './trimestre';

/** Dados de um semestre para os KPI's de produtividade */
export class Semestre {
    semestre: number;
    trimestres: Trimestre[];
    orcamentos: Realizado;
    orcamentosPerdidos: Realizado;
    pedidos: Realizado;

    constructor(props: Partial<Semestre>) {
        Object.assign(this, props);
        // Trimestres
        this.constructorTrimestres(props?.trimestres ?? []);
        // Orçamentos
        this.orcamentos = new Realizado(props?.orcamentos ?? null);
        // Orçamentos Perdidos
        this.orcamentosPerdidos = new Realizado(props?.orcamentosPerdidos ?? null);
        // Pedidos
        this.pedidos = new Realizado(props?.pedidos ?? null);
    }

    /** Constructor para os trimestres */
    private constructorTrimestres(trimestres: Trimestre[]) {
        if (trimestres && Array.isArray(trimestres)) {
            this.trimestres = trimestres.map(trimestre => new Trimestre(trimestre));
        } else {
            this.trimestres = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Semestre {
        return new Semestre(JSON.parse(json));
    }
}
